import { STORE_IS_AUTH_LOADING, STORE_IS_AUTHENTICATION } from "actions"
export const initialState = {
  // 初期Auth処理のローディングに利用
  isAuthLoading: true,
  // 認証済みかどうかを判断
  isAuthentication: false,
  // jwt
  jwt: null,
}

export const DAuth = (state = initialState, action) => {
  switch (action.type) {
    case STORE_IS_AUTH_LOADING:
      return { ...state, isAuthLoading: action.payload }
    case STORE_IS_AUTHENTICATION:
      /*
        isAuthentication: Boolean,
        jwt: JWT,
      */
      return { ...state, ...action.payload }
    default:
      return state
  }
}

export default DAuth
